import React from "react";
import { motion } from "framer-motion";
import { REVEAL, revealDelayed } from "@/lib/motion";

const POINTS = [
  {
    title: "Sales first, tools second.",
    body: "Built by people who have sold and run SDR teams. We know what a good follow-up looks like before we automate it.",
  },
  {
    title: "Tool neutral.",
    body: "lemlist, Pipedrive, HubSpot, n8n, Make, Zapier, WhatsApp or Claude. We recommend what fits and costs the least.",
  },
  {
    title: "You own it.",
    body: "Every workflow runs in your accounts, in your name.",
  },
];

export const HomeWhyRaki = () => (
  <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="home-why-raki">
    <div className="max-w-5xl mx-auto">
      <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">
        Why Raki
      </motion.h2>
      <div className="mt-12 grid md:grid-cols-3 gap-10 md:gap-8">
        {POINTS.map((p, i) => (
          <motion.div key={p.title} {...revealDelayed(i * 0.08)} data-testid={`why-point-${i + 1}`}>
            <div className="h-px w-12 bg-[#C8703A] mb-6" aria-hidden="true" />
            <h3 className="font-fraunces font-extrabold text-base md:text-lg text-[#1F1F1C]">{p.title}</h3>
            <p className="mt-3 text-sm text-[#4A463F] leading-relaxed">{p.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeWhyRaki;
